import Vuex, { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import providers from "./modules/providers.module";
import siteSetting from "./modules/siteSetting.module";
import gameList from "./modules/games.module";

export default createStore({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    providers,
    siteSetting,
    gameList,
  },
});
